// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/installation.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/installation.proto.
 */
export const file_api_gateway_v1_installation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * Installation represents a physical site where devices are deployed.
 *
 * @generated from message gateway.v1.Installation
 */
export type Installation = Message<"gateway.v1.Installation"> & {
  /**
   * uuid is the unique identifier for the installation.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * erp_id is the external ERP identifier for the installation.
   *
   * @generated from field: string erp_id = 2;
   */
  erpId: string;

  /**
   * name is the display name of the installation.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * siphon_type is the flow direction of the siphon (effluent or influent).
   *
   * @generated from field: gateway.v1.SiphonType siphon_type = 4;
   */
  siphonType: SiphonType;

  /**
   * siphon_material is the pipe material of the siphon.
   *
   * @generated from field: gateway.v1.SiphonMaterial siphon_material = 5;
   */
  siphonMaterial: SiphonMaterial;

  /**
   * siphon_diameter_mm is the pipe diameter of the siphon.
   *
   * @generated from field: gateway.v1.SiphonDiameter siphon_diameter_mm = 6;
   */
  siphonDiameterMm: SiphonDiameter;

  /**
   * siphon_effluent_siphon_uuid is a reference to the associated effluent siphon.
   *
   * @generated from field: string siphon_effluent_siphon_uuid = 7;
   */
  siphonEffluentSiphonUuid: string;

  /**
   * siphon_collapse_limit_percentage is the threshold percentage at which the siphon is considered at risk of collapse.
   *
   * @generated from field: uint32 siphon_collapse_limit_percentage = 8;
   */
  siphonCollapseLimitPercentage: number;

  /**
   * installation_state_uuid is the UUID of the current state assigned to this installation.
   *
   * @generated from field: string installation_state_uuid = 9;
   */
  installationStateUuid: string;

  /**
   * other_info contains additional metadata as a flat JSON object.
   *
   * @generated from field: google.protobuf.Struct other_info = 10;
   */
  otherInfo?: JsonObject | undefined;

  /**
   * created_at timestamp when the installation was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at timestamp when the installation was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * location_uuid is the UUID of the location associated with this installation.
   *
   * @generated from field: string location_uuid = 13;
   */
  locationUuid: string;

  /**
   * comment is a description or note about the installation.
   *
   * @generated from field: string comment = 14;
   */
  comment: string;
};

/**
 * Describes the message gateway.v1.Installation.
 * Use `create(InstallationSchema)` to create a new message.
 */
export const InstallationSchema: GenMessage<Installation> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 0);

/**
 * CreateInstallationRequest is the request message for creating a new installation.
 *
 * @generated from message gateway.v1.CreateInstallationRequest
 */
export type CreateInstallationRequest = Message<"gateway.v1.CreateInstallationRequest"> & {
  /**
   * name is the display name for the new installation.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * erp_id is the external ERP identifier for the installation.
   *
   * @generated from field: string erp_id = 2;
   */
  erpId: string;

  /**
   * siphon_type is the flow direction of the siphon (effluent or influent).
   *
   * @generated from field: gateway.v1.SiphonType siphon_type = 3;
   */
  siphonType: SiphonType;

  /**
   * siphon_material is the pipe material of the siphon.
   *
   * @generated from field: gateway.v1.SiphonMaterial siphon_material = 4;
   */
  siphonMaterial: SiphonMaterial;

  /**
   * siphon_diameter_mm is the pipe diameter of the siphon.
   *
   * @generated from field: gateway.v1.SiphonDiameter siphon_diameter_mm = 5;
   */
  siphonDiameterMm: SiphonDiameter;

  /**
   * siphon_effluent_siphon_uuid is a reference to the associated effluent siphon.
   *
   * @generated from field: string siphon_effluent_siphon_uuid = 6;
   */
  siphonEffluentSiphonUuid: string;

  /**
   * siphon_collapse_limit_percentage is the threshold percentage at which the siphon is considered at risk of collapse.
   *
   * @generated from field: uint32 siphon_collapse_limit_percentage = 7;
   */
  siphonCollapseLimitPercentage: number;

  /**
   * location_uuid is the UUID of the location associated with the new installation.
   *
   * @generated from field: string location_uuid = 8;
   */
  locationUuid: string;

  /**
   * comment is a description or note about the installation.
   *
   * @generated from field: string comment = 9;
   */
  comment: string;
};

/**
 * Describes the message gateway.v1.CreateInstallationRequest.
 * Use `create(CreateInstallationRequestSchema)` to create a new message.
 */
export const CreateInstallationRequestSchema: GenMessage<CreateInstallationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 1);

/**
 * CreateInstallationResponse is the response message for the CreateInstallation RPC.
 *
 * @generated from message gateway.v1.CreateInstallationResponse
 */
export type CreateInstallationResponse = Message<"gateway.v1.CreateInstallationResponse"> & {
  /**
   * installation is the newly created installation.
   *
   * @generated from field: gateway.v1.Installation installation = 1;
   */
  installation?: Installation | undefined;
};

/**
 * Describes the message gateway.v1.CreateInstallationResponse.
 * Use `create(CreateInstallationResponseSchema)` to create a new message.
 */
export const CreateInstallationResponseSchema: GenMessage<CreateInstallationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 2);

/**
 * GetInstallationByUuidRequest is the request message for retrieving an installation by UUID.
 *
 * @generated from message gateway.v1.GetInstallationByUuidRequest
 */
export type GetInstallationByUuidRequest = Message<"gateway.v1.GetInstallationByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the installation to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetInstallationByUuidRequest.
 * Use `create(GetInstallationByUuidRequestSchema)` to create a new message.
 */
export const GetInstallationByUuidRequestSchema: GenMessage<GetInstallationByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 3);

/**
 * GetInstallationByUuidResponse is the response message for the GetInstallationByUuid RPC.
 *
 * @generated from message gateway.v1.GetInstallationByUuidResponse
 */
export type GetInstallationByUuidResponse = Message<"gateway.v1.GetInstallationByUuidResponse"> & {
  /**
   * installation is the installation retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.Installation installation = 1;
   */
  installation?: Installation | undefined;
};

/**
 * Describes the message gateway.v1.GetInstallationByUuidResponse.
 * Use `create(GetInstallationByUuidResponseSchema)` to create a new message.
 */
export const GetInstallationByUuidResponseSchema: GenMessage<GetInstallationByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 4);

/**
 * UpdateInstallationRequest is the request message for updating an existing installation.
 *
 * @generated from message gateway.v1.UpdateInstallationRequest
 */
export type UpdateInstallationRequest = Message<"gateway.v1.UpdateInstallationRequest"> & {
  /**
   * uuid is the unique identifier of the installation to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the updated display name.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * erp_id is the updated external ERP identifier.
   *
   * @generated from field: string erp_id = 3;
   */
  erpId: string;

  /**
   * siphon_type is the flow direction of the siphon (effluent or influent).
   *
   * @generated from field: gateway.v1.SiphonType siphon_type = 4;
   */
  siphonType: SiphonType;

  /**
   * siphon_material is the pipe material of the siphon.
   *
   * @generated from field: gateway.v1.SiphonMaterial siphon_material = 5;
   */
  siphonMaterial: SiphonMaterial;

  /**
   * siphon_diameter_mm is the pipe diameter of the siphon.
   *
   * @generated from field: gateway.v1.SiphonDiameter siphon_diameter_mm = 6;
   */
  siphonDiameterMm: SiphonDiameter;

  /**
   * siphon_effluent_siphon_uuid is a reference to the associated effluent siphon.
   *
   * @generated from field: string siphon_effluent_siphon_uuid = 7;
   */
  siphonEffluentSiphonUuid: string;

  /**
   * siphon_collapse_limit_percentage is the threshold percentage at which the siphon is considered at risk of collapse.
   *
   * @generated from field: uint32 siphon_collapse_limit_percentage = 8;
   */
  siphonCollapseLimitPercentage: number;

  /**
   * other_info contains additional metadata as a flat JSON object.
   *
   * @generated from field: google.protobuf.Struct other_info = 9;
   */
  otherInfo?: JsonObject | undefined;

  /**
   * location_uuid is the UUID of the location associated with the updated installation.
   *
   * @generated from field: string location_uuid = 10;
   */
  locationUuid: string;

  /**
   * comment is the updated description or note about the installation.
   *
   * @generated from field: string comment = 11;
   */
  comment: string;
};

/**
 * Describes the message gateway.v1.UpdateInstallationRequest.
 * Use `create(UpdateInstallationRequestSchema)` to create a new message.
 */
export const UpdateInstallationRequestSchema: GenMessage<UpdateInstallationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 5);

/**
 * UpdateInstallationResponse is the response message for the UpdateInstallation RPC.
 *
 * @generated from message gateway.v1.UpdateInstallationResponse
 */
export type UpdateInstallationResponse = Message<"gateway.v1.UpdateInstallationResponse"> & {
  /**
   * installation is the updated installation.
   *
   * @generated from field: gateway.v1.Installation installation = 1;
   */
  installation?: Installation | undefined;
};

/**
 * Describes the message gateway.v1.UpdateInstallationResponse.
 * Use `create(UpdateInstallationResponseSchema)` to create a new message.
 */
export const UpdateInstallationResponseSchema: GenMessage<UpdateInstallationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 6);

/**
 * DeleteInstallationRequest is the request message for deleting an installation.
 *
 * @generated from message gateway.v1.DeleteInstallationRequest
 */
export type DeleteInstallationRequest = Message<"gateway.v1.DeleteInstallationRequest"> & {
  /**
   * uuid is the unique identifier of the installation to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteInstallationRequest.
 * Use `create(DeleteInstallationRequestSchema)` to create a new message.
 */
export const DeleteInstallationRequestSchema: GenMessage<DeleteInstallationRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 7);

/**
 * DeleteInstallationResponse is the response message for the DeleteInstallation RPC.
 *
 * @generated from message gateway.v1.DeleteInstallationResponse
 */
export type DeleteInstallationResponse = Message<"gateway.v1.DeleteInstallationResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteInstallationResponse.
 * Use `create(DeleteInstallationResponseSchema)` to create a new message.
 */
export const DeleteInstallationResponseSchema: GenMessage<DeleteInstallationResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 8);

/**
 * GetAllInstallationsByLocationUuidRequest is the request message for retrieving all installations associated with a specific location UUID.
 *
 * @generated from message gateway.v1.GetAllInstallationsByLocationUuidRequest
 */
export type GetAllInstallationsByLocationUuidRequest = Message<"gateway.v1.GetAllInstallationsByLocationUuidRequest"> & {
  /**
   * location_uuid is the unique identifier of the location to retrieve installations for.
   *
   * @generated from field: string location_uuid = 1;
   */
  locationUuid: string;
};

/**
 * Describes the message gateway.v1.GetAllInstallationsByLocationUuidRequest.
 * Use `create(GetAllInstallationsByLocationUuidRequestSchema)` to create a new message.
 */
export const GetAllInstallationsByLocationUuidRequestSchema: GenMessage<GetAllInstallationsByLocationUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 9);

/**
 * GetAllInstallationsByLocationUuidResponse is the response message for the GetAllInstallationsByLocationUuid RPC.
 *
 * @generated from message gateway.v1.GetAllInstallationsByLocationUuidResponse
 */
export type GetAllInstallationsByLocationUuidResponse = Message<"gateway.v1.GetAllInstallationsByLocationUuidResponse"> & {
  /**
   * installations is the list of installations associated with the specified location UUID.
   *
   * @generated from field: repeated gateway.v1.Installation installations = 1;
   */
  installations: Installation[];
};

/**
 * Describes the message gateway.v1.GetAllInstallationsByLocationUuidResponse.
 * Use `create(GetAllInstallationsByLocationUuidResponseSchema)` to create a new message.
 */
export const GetAllInstallationsByLocationUuidResponseSchema: GenMessage<GetAllInstallationsByLocationUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation, 10);

/**
 * SiphonType defines the flow direction of a siphon.
 *
 * @generated from enum gateway.v1.SiphonType
 */
export enum SiphonType {
  /**
   * Unspecified siphon type, used as a default value.
   *
   * @generated from enum value: SIPHON_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Effluent siphon type, indicating outgoing flow.
   *
   * @generated from enum value: SIPHON_TYPE_EFFLUENT = 1;
   */
  EFFLUENT = 1,

  /**
   * Influent siphon type, indicating incoming flow.
   *
   * @generated from enum value: SIPHON_TYPE_INFLUENT = 2;
   */
  INFLUENT = 2,
}

/**
 * Describes the enum gateway.v1.SiphonType.
 */
export const SiphonTypeSchema: GenEnum<SiphonType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation, 0);

/**
 * SiphonMaterial defines the material of a siphon pipe.
 *
 * @generated from enum gateway.v1.SiphonMaterial
 */
export enum SiphonMaterial {
  /**
   * Unknown material, used as a default value.
   *
   * @generated from enum value: SIPHON_MATERIAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PVC (Polyvinyl chloride) pipe material.
   *
   * @generated from enum value: SIPHON_MATERIAL_PVC = 1;
   */
  PVC = 1,

  /**
   * HDPE (High-density polyethylene) pipe material.
   *
   * @generated from enum value: SIPHON_MATERIAL_HDPE = 2;
   */
  HDPE = 2,

  /**
   * Other pipe material not listed above.
   *
   * @generated from enum value: SIPHON_MATERIAL_OTHER = 3;
   */
  OTHER = 3,
}

/**
 * Describes the enum gateway.v1.SiphonMaterial.
 */
export const SiphonMaterialSchema: GenEnum<SiphonMaterial> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation, 1);

/**
 * SiphonDiameter defines the standard pipe diameters available for siphons.
 *
 * @generated from enum gateway.v1.SiphonDiameter
 */
export enum SiphonDiameter {
  /**
   * Unspecified diameter, used as a default value.
   *
   * @generated from enum value: SIPHON_DIAMETER_UNSPECIFIED = 0;
   */
  SIPHON_DIAMETER_UNSPECIFIED = 0,

  /**
   * 90 mm diameter pipe.
   *
   * @generated from enum value: SIPHON_DIAMETER_90_MM = 1;
   */
  SIPHON_DIAMETER_90_MM = 1,

  /**
   * 110 mm diameter pipe.
   *
   * @generated from enum value: SIPHON_DIAMETER_110_MM = 2;
   */
  SIPHON_DIAMETER_110_MM = 2,

  /**
   * 160 mm diameter pipe.
   *
   * @generated from enum value: SIPHON_DIAMETER_160_MM = 3;
   */
  SIPHON_DIAMETER_160_MM = 3,

  /**
   * 200 mm diameter pipe.
   *
   * @generated from enum value: SIPHON_DIAMETER_200_MM = 4;
   */
  SIPHON_DIAMETER_200_MM = 4,

  /**
   * 240 mm diameter pipe.
   *
   * @generated from enum value: SIPHON_DIAMETER_240_MM = 5;
   */
  SIPHON_DIAMETER_240_MM = 5,

  /**
   * Other diameter not listed above.
   *
   * @generated from enum value: SIPHON_DIAMETER_OTHER = 6;
   */
  SIPHON_DIAMETER_OTHER = 6,
}

/**
 * Describes the enum gateway.v1.SiphonDiameter.
 */
export const SiphonDiameterSchema: GenEnum<SiphonDiameter> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation, 2);

/**
 * SiphonEffluentType defines the type of effluent flowing through a siphon.
 *
 * @generated from enum gateway.v1.SiphonEffluentType
 */
export enum SiphonEffluentType {
  /**
   * Unknown effluent type, used as a default value.
   *
   * @generated from enum value: SIPHON_EFFLUENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Other effluent type not listed above.
   *
   * @generated from enum value: SIPHON_EFFLUENT_TYPE_OTHER = 1;
   */
  OTHER = 1,
}

/**
 * Describes the enum gateway.v1.SiphonEffluentType.
 */
export const SiphonEffluentTypeSchema: GenEnum<SiphonEffluentType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation, 3);

/**
 * InstallationService defines the gRPC service for managing installations.
 *
 * -------------------------------------------------------------------------
 * Installation CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.InstallationService
 */
export const InstallationService: GenService<{
  /**
   * CreateInstallation creates a new installation in the system.
   *
   * @generated from rpc gateway.v1.InstallationService.CreateInstallation
   */
  createInstallation: {
    methodKind: "unary";
    input: typeof CreateInstallationRequestSchema;
    output: typeof CreateInstallationResponseSchema;
  },
  /**
   * GetInstallationByUuid retrieves an installation by its unique identifier.
   *
   * @generated from rpc gateway.v1.InstallationService.GetInstallationByUuid
   */
  getInstallationByUuid: {
    methodKind: "unary";
    input: typeof GetInstallationByUuidRequestSchema;
    output: typeof GetInstallationByUuidResponseSchema;
  },
  /**
   * UpdateInstallation updates an existing installation.
   *
   * @generated from rpc gateway.v1.InstallationService.UpdateInstallation
   */
  updateInstallation: {
    methodKind: "unary";
    input: typeof UpdateInstallationRequestSchema;
    output: typeof UpdateInstallationResponseSchema;
  },
  /**
   * DeleteInstallation removes an installation from the system.
   *
   * @generated from rpc gateway.v1.InstallationService.DeleteInstallation
   */
  deleteInstallation: {
    methodKind: "unary";
    input: typeof DeleteInstallationRequestSchema;
    output: typeof DeleteInstallationResponseSchema;
  },
  /**
   * GetAllInstallationsByLocationUuid retrieves all installations associated with a specific location UUID.
   *
   * @generated from rpc gateway.v1.InstallationService.GetAllInstallationsByLocationUuid
   */
  getAllInstallationsByLocationUuid: {
    methodKind: "unary";
    input: typeof GetAllInstallationsByLocationUuidRequestSchema;
    output: typeof GetAllInstallationsByLocationUuidResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_installation, 0);

